<template>
  <svg :class="svgClass" aria-hidden="true" @click="clickIcon">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'mobile-icon',
  props: {
    icon: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    svgClass() { // svg 的class
      if (this.className) {
        return `${this.className}`
      } else {
        return 'svg-icon'
      }
    },
    iconName() { // svg xlink-href 指向的文件名
      return `#icon-${this.icon}`
    }
  },
  methods: {
    clickIcon() {
      this.$emit('clickIcon')
    }
  }
}
</script>

<style scoped>
.svg-icon{
  width: 48px;
  height: 48px;
  fill: currentColor;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile-icon/index.vue